import { LocationPickerData, UnitPickerData } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/EmbedPicker/EmbedPicker.Controller.ts
//
// Public-ish picker API used by the chat-widget for direct fetches that
// don't go through the bot's LLM (radius filter changes, chained units
// fetch after a location pick, change-location sub-flow, etc.). Auth is
// `AuthType.USER_JWT_TOKEN` — the widget passes its anonymous-user JWT
// in the `x-access-token` header.
//
// See `/Users/chuck/.claude/plans/ancient-percolating-lantern.md` §A4.

export interface GetEmbedLocationsQuery {
  postalCode?: string;
  distance?: number;
  lat?: number;
  lng?: number;
  botConversationId?: number;
  sourceMessageId?: string;
  sourceAction?: "filter_change" | "chained_units_fetch" | "use_my_location" | "zip_entry_submit" | "change_location_subflow";
}

export interface GetEmbedUnitsQuery {
  sizeBucket?: "small" | "medium" | "large" | "extra-large";
  climateOnly?: boolean;
  driveUpOnly?: boolean;
  sortBy?: "price" | "size";
  available?: boolean;
  botConversationId?: number;
  sourceMessageId?: string;
  sourceAction?: "filter_change" | "chained_units_fetch" | "use_my_location" | "zip_entry_submit" | "change_location_subflow";
}

export class EmbedPickerAPI {
  static async getLocations(orgId: number, params: GetEmbedLocationsQuery = {}): Promise<LocationPickerData> {
    return APIService.Server.get<LocationPickerData>(`/embed-picker/org/${orgId}/locations`, params);
  }

  static async getUnits(orgId: number, locationId: number, params: GetEmbedUnitsQuery = {}): Promise<UnitPickerData> {
    return APIService.Server.get<UnitPickerData>(`/embed-picker/org/${orgId}/locations/${locationId}/units`, params);
  }
}
